import { render, staticRenderFns } from "./AIChatModule.vue?vue&type=template&id=59e3167e&scoped=true"
import script from "./AIChatModule.vue?vue&type=script&lang=js"
export * from "./AIChatModule.vue?vue&type=script&lang=js"
import style0 from "./AIChatModule.vue?vue&type=style&index=0&id=59e3167e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e3167e",
  null
  
)

export default component.exports